export default {
  strict: true,
  namespaced: true,
  state: [],
  getters: {
    all: (state) => {
      return state.reverse()
    }
  },
  mutations: {
    add: (state, payload) => {
      state.push({
        name: payload.name,
        params: payload.params
      })
    }
  }
}
